import TimerOutlinedIcon from '@material-ui/icons/TimerOutlined';
import { Chip } from '@opendoor/mosaic';
import moment from 'moment';

interface CountDownFieldProps {
  progress: string;
  dateRequestedAt: string;
  scheduledStartAt: string;
  scheduledStopAt: string;
}

const CountDownField = (props: CountDownFieldProps) => {
  const { progress, dateRequestedAt, scheduledStartAt, scheduledStopAt } = props;

  switch (progress) {
    case 'NEW': {
      if (moment().isAfter(moment(dateRequestedAt).add(3, 'days'), 'date')) {
        return (
          <>
            <div>
              <Chip label="Overdue" className="red4 bg-red1" />
            </div>
            <div className="flex items-center mt-2 mr-2 neutral90">
              <TimerOutlinedIcon />
              by {moment(dateRequestedAt).add(3, 'days').fromNow(true)}
            </div>
          </>
        );
      } else {
        return (
          <>
            <div>
              <Chip label="Approaching" className="yellow4 bg-yellow1" />
            </div>
            <div className="flex items-center mt-2 mr-2 neutral90">
              <TimerOutlinedIcon />
              in {moment(dateRequestedAt).add(3, 'days').fromNow(true)}
            </div>
          </>
        );
      }
    }
    case 'WAITING_FOR_ALLOWED_START': {
      return (
        <>
          <div>
            <Chip label="Approaching" className="yellow4 bg-yellow1" />
          </div>
          <div className="flex items-center mt-2 mr-2 neutral90">
            <TimerOutlinedIcon />
            in {moment(scheduledStartAt).fromNow(true)}
          </div>
        </>
      );
    }
    case 'READY_TO_START': {
      return (
        <>
          <div>
            <Chip label="Overdue" className="red4 bg-red1" />
          </div>
          <div className="flex items-center mt-2 mr-2 neutral90">
            <TimerOutlinedIcon />
            by {moment(scheduledStartAt).fromNow(true)}
          </div>
        </>
      );
    }
    case 'IN_PROGRESS':
    case 'REWORK_NEEDED': {
      if (moment().isAfter(scheduledStopAt, 'date')) {
        return (
          <>
            <div>
              <Chip label="Overdue" className="red4 bg-red1" />
            </div>
            <div className="flex items-center mt-2 mr-2 neutral90">
              <TimerOutlinedIcon />
              by {moment(scheduledStopAt).fromNow(true)}
            </div>
          </>
        );
      }

      return (
        <>
          <div>
            <Chip label="Approaching" className="yellow4 bg-yellow1" />
          </div>
          <div className="flex items-center mt-2 mr-2 neutral90">
            <TimerOutlinedIcon />
            in {moment(scheduledStopAt).fromNow()}
          </div>
        </>
      );
    }
    default: {
      return <>-</>;
    }
  }
};

export default CountDownField;
